module.exports = __webpack_public_path__ + "static/media/crown_touch2.77094293.jpg";